<template>
    <div class="login-wrapper">
            <h1>Reset Your Password</h1>
            <form @submit="submit">
                <label>
                    <span>New password</span>
                    <input type="password" v-model="password" placeholder="">
                </label>
                <button type="submit" class="button-blue">Button</button>
            </form>
            <a style="text-align: center;text-decoration: none;" href="/"><span class="return-login blue">Return to login</span></a>
        </div>
</template>

<script>
import { resetPasswordConfirm, resetConfirm } from '../api/auth.js';
export default {

  data() {
    return {
        email:'',
        token:'',
        password:'',
    };
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      await resetConfirm({login:this.$route.query.email,password:this.password})
      this.$router.push("/")
    },

  },
  name: "ResetPasswordConfirm",
  components: {
  },
  async mounted() {
    await resetPasswordConfirm(this.$route.query.email, this.$route.query.tokenReset)

  }
};
</script>
